interface ToastOptions {
  title: string
  message?: string
  duration?: number
}

export const toast = {
  /**
   * Show a success toast
   * @param options - The options for the toast
   */
  success(options: ToastOptions) {
    window.dispatchEvent(
      new CustomEvent('toast:success', {
        detail: options
      })
    )
  },

  /**
   * Show an error toast
   * @param options - The options for the toast
   */
  error(options: ToastOptions) {
    window.dispatchEvent(
      new CustomEvent('toast:error', {
        detail: options
      })
    )
  }
} 